import app from 'flarum/forum/app';
app.initializers.add('val-ui-home-tree-tags', () => {
  const loaded = new Map();
  const loading = new Set();
  function parentIdFromTile(tile) {
    const link = tile && tile.querySelector('a.TagTile-info[href]');
    if (!link) return null;
    let pathname;
    try {
      pathname = new URL(link.getAttribute('href') || '', window.location.origin).pathname;
    } catch (e) {
      return null;
    }
    const match = pathname.match(/^\/t\/([^/?#]+)/);
    if (!match) return null;
    let value;
    try {
      value = decodeURIComponent(match[1]);
    } catch (e) {
      value = match[1];
    }
    const idMatch = String(value).match(/^(\d+)(?:-|$)/);
    if (idMatch) {
      return idMatch[1];
    }
    if (!app.store || typeof app.store.all !== 'function') {
      return null;
    }
    const tag = app.store.all('tags').find(tag => {
      if (!tag || typeof tag.slug !== 'function') return false;
      return String(tag.slug()) === String(value);
    });
    return tag && typeof tag.id === 'function' ? String(tag.id()) : null;
  }
  function loadParent(parentId) {
    if (!parentId || loaded.has(parentId) || loading.has(parentId) || !app.forum || typeof app.forum.attribute !== 'function') {
      return;
    }
    loading.add(parentId);
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/val/ui/tree-tags?parent=' + encodeURIComponent(parentId)
    }).then(result => {
      loaded.set(parentId, result && Array.isArray(result.tags) ? result.tags : []);
      loading.delete(parentId);
      render();
    }).catch(() => {
      loading.delete(parentId);
    });
  }
  function render() {
    document.querySelectorAll('.TagsPage .TagTile').forEach(tile => {
      const parentId = parentIdFromTile(tile);
      if (!parentId) return;
      loadParent(parentId);
      if (!loaded.has(parentId)) return;
      const rows = loaded.get(parentId) || [];
      let container = tile.querySelector('.TagTile-children');
      if (!rows.length) {
        return;
      }
      const parentLink = tile.querySelector('a.TagTile-info[href]');
      if (!parentLink) {
        return;
      }
      let main = tile.querySelector(':scope > .val-tag-tile-main');
      if (!main) {
        main = document.createElement('div');
        main.className = 'val-tag-tile-main';
        parentLink.parentNode.insertBefore(main, parentLink);
        main.appendChild(parentLink);
      }
      if (!container) {
        container = document.createElement('div');
        container.className = 'TagTile-children';
      }
      if (container.parentElement !== main) {
        main.appendChild(container);
      }
      const signature = rows.map(row => String(row.id) + ':' + String(row.slug) + ':' + (row.can_access ? '1' : '0')).join('|');
      if (container.dataset.valTreeSignature === signature) {
        return;
      }
      container.replaceChildren();
      rows.forEach((row, index) => {
        const link = document.createElement('a');
        link.href = row.can_access ? '/t/' + encodeURIComponent(row.slug) : '/acces-reserve';
        link.textContent = row.name;
        if (!row.can_access) {
          link.dataset.valTreeOnly = '1';
        }
        container.appendChild(link);
        if (index < rows.length - 1) {
          container.appendChild(document.createTextNode(' '));
        }
      });
      container.dataset.valTreeSignature = signature;
    });
  }

  /*
   * Mithril peut reconstruire les liens natifs après notre rendu.
   * On intercepte donc aussi les clics au niveau du document, en se
   * basant exclusivement sur can_access renvoyé par l'API Flarum.
   */
  document.addEventListener('click', event => {
    const link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!link) return;
    let pathname;
    try {
      pathname = new URL(link.href, window.location.origin).pathname;
    } catch (e) {
      return;
    }
    const match = pathname.match(/^\/t\/(.+)$/);
    if (!match) return;
    let value;
    try {
      value = decodeURIComponent(match[1]);
    } catch (e) {
      value = match[1];
    }
    const idMatch = String(value).match(/^(\\d+)(?:-(.*))?$/);
    const clickedId = idMatch ? idMatch[1] : null;
    const clickedSlug = idMatch && idMatch[2] ? idMatch[2] : String(value);
    let denied = false;
    loaded.forEach(rows => {
      if (denied) return;
      denied = rows.some(row => {
        if (!row || row.can_access !== false) return false;
        if (clickedId && String(row.id) === String(clickedId)) {
          return true;
        }
        return String(row.slug) === String(clickedSlug);
      });
    });
    if (!denied) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    m.route.set('/acces-reserve');
  }, true);
  let timer = null;
  function schedule() {
    if (timer !== null) return;
    timer = window.setTimeout(() => {
      timer = null;
      render();
    }, 40);
  }
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true
  });
  schedule();
});